import { getHomeDestination, homeDestinationAccess } from './homeDestinations';
import { openCollectionWall } from '../../../portals/orders/collection/collectionLineReset';
import { enterHome } from '../../shell/enterHome';
import { openNamesAddress } from '../../../portals/orders/names/namesAddress';
import { openBook } from '../../../portals/book/bookStore';

export function navigateHomeDestination(id, {canAccessPortal,onSelectPortal,ui,orders,projects,requestQc,isQcManager,prepareOrders}) {
  const target = getHomeDestination(id);
  if (!target || !homeDestinationAccess(target, canAccessPortal) || (target.managerOnly && !isQcManager)) return false;
  if (target.portal === 'projects' && !target.projectsView) { projects.openChooser(); return true; }
  // ORD-BOOK-1 · the book is a full-screen surface over the current screen: nothing underneath changes
  if (target.book) { openBook(target.book); return true; }
  // CLB-069 · every Collection destination opens the plain Wall — never Overview ("Coming soon"). A person with Orders
  // access gets the full Collection world (inside Orders); a Collection-only person gets the viewer page (tab `collection`).
  const collection = target.portal === 'collection';
  const inOrders = collection && !!canAccessPortal('orders');
  // Entry callback resets Developments state; apply the named destination after it.
  if (onSelectPortal && !['lens','acetate','files'].includes(target.portal)) onSelectPortal(inOrders ? 'orders' : target.portal);
  ui.setDevView('board'); ui.setAnalyticsView(null); ui.setSettingsView(null);
  if (target.devView) ui.setDevView(target.devView);
  if (target.portal === 'sales') ui.setSalesView(target.salesView || 'items');
  if (target.portal === 'projects') projects.setProjectsView(target.projectsView || 'selection');
  if (target.portal === 'orders' && target.world) {
    if (prepareOrders) prepareOrders(target);
    orders.setWorld(target.world);
    if (target.deskView) orders.setDeskView(target.deskView);
    if (target.ordersView) orders.setOrdersView(target.ordersView);
  }
  // ORD-NAMES-2 · the Names card: Orders opens with the Names department (it reads names=1 on mount)
  if (target.names) openNamesAddress();
  if (collection) {
    if (inOrders && prepareOrders) prepareOrders({ world: 'collection', collectionLine: target.collectionLine });
    openCollectionWall(orders, target.collectionLine || orders.bookKind);
    if (inOrders) orders.setWorld('collection');
  }
  if (target.portal === 'qc') requestQc(target.qcView || 'reports');
  const tabs = {catalog:'catalog',developments:'developments',orders:'orders',qc:'qc',sales:'sales_portal',projects:'projects',collection:'collection',lens:'lensBank',acetate:'acetateBank',files:'filesBank'};
  ui.setTab(inOrders ? 'orders' : target.tab || tabs[target.portal]);
  // CLB-080 S5 · a card for the whole portal (no section named) opens on the Home pinned in its Navigator
  // (not Originals: its "Catalog" link and its card share one id, so a named section cannot be told from the portal)
  if (target.portal !== 'catalog' && !target.devView && !target.salesView && !target.tab && !target.projectsView) enterHome(target.portal, ui);
  ui.setEntryPhase('app');
  return true;
}
